import { Intl } from '@erecruit/core';

const customMessages: Intl.LocalizationValues = {
  vms: {
    comingSoon: {
      title: 'Coming soon',
      description: 'We are still working on this page',
    },
    widgets: {
      table: {
        shifts: {
          range: {
            title: 'Displayed days:',
            today: 'Today',
            next7Days: 'Next 7 days',
          },
        },
      },
    },
    settings: {
      profile: 'Profile',
      appearance: {
        pageTitle: 'Appearance',
        chooseTheme: 'Choose theme:',
        lightTheme: 'Light Theme',
        darkTheme: 'Dark Theme',
      },
      data: {
        heading: 'Data Preferences',
        noAssociatedDepartments:
          'There are no departments associated with this company',
        emptyDepartmentsWarning:
          'Empty departments selection has the same meaning as selecting all departments',
        emptyPositionTypesWarning:
          'Empty position types selection has the same meaning as selecting all position types',
        recordPick: 'Choose record you want to see:',
        myOwn: 'My Own',
        myCompany: 'My Company',
        companiesFilterTitle: 'Select departments in companies:',
        positionTypeFilterTitle: 'Select position types:',
        initializing: 'Initializing data preferences...',
      },
      notifications: {
        heading: 'Notifications',
        nameColumn: 'Notification',
        statusColumn: 'Status',
        error: 'Error fetching notification settings',
        initializing: 'Fetching notification settings',
        comingSoon: '(coming soon)',
      },
      approvals: 'Approvals',
      help: 'Help / FAQ',
      about: 'About',
      loadMore: 'Load more...',
      initializing: 'Initializing settings...',
    },
    reportProblem: {
      title: 'Report a Technical Problem',
      pageTitle: 'Report a Problem',
      subject: 'Subject',
      description: 'Description',
      okText: 'Submit',
      cancel: 'Cancel',
      submit: 'Submit',
      progressInfo: 'This will take a few seconds',
      successInfo: 'Feedback has been successfully submitted',
      submittingHeaderText: 'Report a Problem',
      attachFiles: 'Attach files',
      maximumNumberOfFilesRule: 'Maximum number of files is {maxFilesCount}',
      maximumSizeRule:
        'Maximum attachments size is {maxAttachmentSize} megabytes',
      uploadInProgress: 'Upload is still in progress',
    },
    quickSearch: {
      placeholder: 'Search by name, ID, phone or email',
      candidates: 'Candidates',
      searchTooShort: 'Min. 2 characters',
      noDataTitle: 'No search result',
      noDataDescription: 'Sorry, we couldn’t find what you’re looking for',
    },
    general: {
      placeholder: '{placeholder}',
      dayUnknown: 'Day(s)',
      weekUnknown: 'Week(s)',
      monthUnknown: 'Month(s)',
      yearUnknown: 'Year(s)',
      dayRelative:
        '{value} {value, plural, =0 { days } one {day} other {days}}',
      weekRelative:
        '{value} {value, plural, =0 { weeks } one {week} other {weeks}}',
      monthRelative:
        '{value} {value, plural, =0 { months } one {month} other {months}}',
      yearRelative:
        '{value} {value, plural, =0 { years } one {year} other {years}}',
      base: 'Base',
      project: 'Project',
    },
    login: {
      unsupportedRole: 'Cannot log in with current role.',
      unsupportedRoleDescription: "User can only log in with 'Contact' role",
      redirectToLogIn: 'Return to log in',
    },
    actions: {
      filter: 'Filter',
      save: 'Save',
      cancel: 'Cancel',
      export: 'Export',
      reset: 'Reset',
      apply: 'OK',
    },
    errors: {
      form: {
        requiredField: 'This field is required.',
      },
      generic: 'Error has occured.',
      noData: 'No data.',
      retry: 'Try again',
    },
    matches: {
      matches: 'Matches',
      all: 'All Matches',
      currentlyWorking: 'Currently Working',
      submittals: 'Submittals',
      endingSoon: 'Ending Soon',
      pendingStart: 'Pending Start',
      pendingMyApproval: 'Pending My Approval',
    },
    matchSearch: {
      approvalStatus: 'Approval Status',
      billRate: 'Bill Rate',
      company: 'Company',
      createdOn: 'Created Date',
      facilityDepartments: 'Departments',
      name: 'Match',
      candidate: 'Candidate',
      position: 'Position',
      positionCompany: 'Position/Company Name',
      positionOwner: 'Position Owner',
      positionType: 'Position Type',
      submittedBy: 'Submitted By',
      requirements: 'Requirements',
      estimatedStartDate: 'Est. Start Date',
      estimatedEndDate: 'Est. End Date',
      actualEndDate: 'Actual End Date',
      startConfirmed: 'Start Confirmed',
      status: 'Status',
      worksite: 'Worksite',
      submittedOn: 'Submitted Date',
      vendor: 'Vendor',
      contact: 'Contact',
      approvalPath: 'Approval Status',
      activityStatus: {
        PendingStart: 'Pending Start',
        EndingSoon: 'Ending Soon',
        Ended: 'Ended',
      },
    },
    positionSearch: {
      addNewPosition: 'Add New',
      name: 'Position',
      positionType: 'Position Type',
      companyDepartments: 'Departments',
      company: 'Company',
      worksite: 'Worksite',
      contact: 'Contact',
      createdOn: 'Created On',
      estimatedStartDate: 'Est. Start Date',
      estimatedEndDate: 'Est. End Date',
      startTime: 'Start Time',
      endTime: 'End Time',
      positionStatus: 'Status',
      noDataMessage: 'There are no open positions at the moment',
      approvalPath: 'Approval Status',
    },
    shiftSearch: {
      noDataMessage: 'No data',
      noCandidateMessage: 'No candidate yet!',
      noPositionMessage: 'Position not found',
      startDate: 'Start Date',
      end: 'End',
      start: 'Start',
      shiftStatus: 'Shift Status',
      company: 'Company',
      candidate: 'Candidate',
      shiftTime: 'Start/End Time',
      position: 'Position',
      shiftType: 'Shift Type',
      facilityDepartment: 'Departments',
      createdOn: 'Date Created',
      createdBy: 'Created By',
      worksite: 'Location',
      cancellationReason: 'Cancellation Reason',
      description: 'Description',
      shiftId: 'Shift',
      actions: {
        edit: 'Edit',
        cancel: 'Cancel',
        cancellationNote: 'Cancellation Note',
        cancelText: 'No',
        okText: 'Yes',
        text: 'Are you sure you want to cancel this shift?',
        cancelShift: 'Cancel shift',
        title: 'Caution',
        progressInfo:
          'Please wait until shift {shiftName} on position {positionName} is cancelled',
        actionTitle: 'Cancelling Shift {shiftName} on position {positionName}',
        successInfo: 'Shift {shiftName} is cancelled successfully',
      },
    },
    shifts: {
      addNewShift: 'Add new shift',
      shifts: 'Shifts',
      all: 'All Shifts',
      filled: 'Filled Shifts',
      unfilled: 'Unfilled Shifts',
      cancelled: 'Cancelled Shifts',
    },
    positions: {
      positions: 'Positions',
      all: 'All Positions',
      noPositions: 'No positions.',
      noCandidates: 'No candidates.',
      openPositionText: 'Open Positions',
      closePositionText: 'Closed Positions',
      createPosition: 'Create Position',
      pendingMyApproval: 'Pending My Approval',
    },
    currencySymbol: '$',
    currencySuffix: '/hour',
    menu: {
      dashboard: 'Dashboard',
      positions: 'Positions',
      shifts: 'Shifts',
      matches: 'Matches',
      timesheets: 'Timesheets',
      reports: 'Reports',
      settings: 'Settings',
      logout: 'Logout',
    },
    notification: {
      cancelText: 'Dismiss',
      okText: 'Mark as read',
      markAsRead: 'Mark as read',
    },
    notifications: {
      notificationModalTitle: 'Newest',
      notificationPageTitle: 'Notifications History',
      types: {
        candidateSubmitted: 'Candidate Submitted',
        matchApprovalCompleted: 'Match Approval Path Approved',
        matchApprovalPending: 'Match Pending Approval',
        matchApprovalRejected: 'Match Approval Path Rejected',
        matchApprovalStarted: 'Match Approval Started',
        positionApprovalCompleted: 'Position Approval Path Approved',
        positionApprovalPending: 'Position Pending Approval',
        positionApprovalRejected: 'Position Approval Path Rejected',
        positionApprovalStarted: 'Position Approval Started',
        candidateAcceptedOffer: 'Candidate Accepted Offer',
        positionApprovalNeedsApprovers:
          'Position Needs Ad Hoc Approvers Specified',
        matchApprovalNeedsApprovers: 'Match Needs Approvers',
      },
      link: 'Review now',
    },
    notificationPopup: {
      title: 'Notifications',
      markAllAsReadCaption: 'Mark all as read',
      emptyMessage: 'You have no notifications yet.',
      settingsCaption: 'Settings',
      historyCaption: 'History',
      loadMore: 'Load more...',
    },
    newShiftWizard: {
      general: {
        positionTitle: 'Position Title',
        department: 'Department',
        shiftType: 'Shift Type',
        startTime: 'Start Time',
        endTime: 'End Time',
        selection: 'Selection',
        range: 'Range',
        selectShifts: 'Select Shifts',
        review: 'Review',
        submit: 'Submit',
      },
      positionSearch: {
        searchPlaceholder: 'Search positions by name',
        title: 'Existing Position',
        subtitle: 'Shifts will be added to the order you select',
      },
      review: {
        title: 'Review and Submit',
        disclaimer: 'Double check shift details before you hit the submit',
        subtitle: 'Shift',
        addDate: 'Add Date',
      },
      addShift: {
        loadingMessage: 'This will take a few seconds',
        successMessage: 'Successfully created {count} shifts for {position}',
        noDatesSelected: 'At least one day needs to be selected.',
        title: 'Schedule',
        subTitle: 'Shifts will be added to the order you selected',
      },
      addNew: 'Add another shift',
      title: 'Add new shift',
    },
    newPositionWizard: {
      requestPosition: {
        title: 'Request Position',
        description:
          'To create a new position, tell us what type of talent you need',
        searchPlaceholder: 'Search positions templates by name',
        templates: 'Templates',
        savingMessage: 'Please wait while position {position} is created',
        successMessage: 'Position {position} created successfully',
        savingTitle: 'Creating position {position}',
        chooseCompany: 'Choose company...',
        noPositionTemplates:
          'Select company above to show related position templates',
        company: 'Company',
      },
      general: {
        positionTitle: 'Position Title',
        positionTitlePlaceholder: 'Position Title',
        positionType: 'Position Type',
        positionTypePlaceholder: 'Select position type',
        numberOfPositions: 'Number Of Positions',
        positionDescription: 'Position Description',
        supervisor: 'Supervisor',
        agreement: 'Agreement',
        maxNumberOfSubmittals: 'Max Number Of Submittals',
        opportunity: 'Opportunity',
        primaryDepartment: 'Primary Department',
        reportsTo: 'Reports To',
        submittalLimitPerVendor: 'Submittal Limit Per Vendor',
        travelPercentage: 'Travel Percentage',
        clientProject: 'Client Project',
        folderGroup: 'Folder Group',
        title: 'General',
        disclaimer:
          'Please provide or update information about your position request.',
      },
      location: {
        worksiteAddress: 'Worksite Address',
        worksiteLocationPlaceholder: 'Select worksite location',
        facilityDepartments: 'Departments',
        workFromHome: 'Work From Home',
        title: 'Location',
        disclaimer: 'Where do you need your workers to show up?',
      },
      schedule: {
        shiftTypes: 'Shift Types',
        startTime: 'Start Time',
        endTime: 'End Time',
        estimatedStartTime: 'Start Time',
        estimatedEndTime: 'End Time',
        workingDuration: 'Working Duration',
        estimatedStartDate: 'Estimated Start Date',
        estimatedEndDate: 'Estimated End Date',
        duration: 'Duration',
        title: 'Schedule',
        disclaimer: 'Select an estimated start date.',
      },
      review: {
        positionCreationReason: 'Position Creation Reason',
        positionCreationReasonNote: 'Position Creation Reason Note',
        generalComments: 'General Comments',
        positionTitle: 'POSITION TITLE',
        positionEstimatedStartDate: 'EST. START DATE',
        positionEstimatedDuration: 'EST. DURATION',
        positionEstimatedEndDate: 'EST. END DATE',
        positionNumber: 'NUMBER OF POSITIONS',
        positionType: 'POSITION TYPE',
        positionWorksite: 'WORKSITE LOCATION',
        positionDepartments: 'DEPARTMENTS',
        positionTargetBillRate: 'TARGET BILL RATE',
        positionEstimatedSpend: 'ESTIMATED SPEND',
        title: 'Review and Submit',
        disclaimer:
          'Double check position details and tell us anything else you want us to know.',
      },
      billing: {
        estimatedSpend: 'Estimated Spend',
        title: 'Billing',
        disclaimer: 'Review billing details and estimates',
        targetBillRate: 'Bill Rate',
        requestFundingDetails: 'Request Funding Details',
        requestFundingDetailsPlaceholder: 'Enter details',
        requestFunding: 'Request Funding',
        maximumBillRate: 'Maximum Bill Rate',
        minimumBillRate: 'Minimum Bill Rate',
        noBillRatesMessage:
          'We cannot identify a rate based on the information supplied.',
        maximumBillRateDescription: 'or less.',
        minimumBillRateDescription: 'or greater.',
      },
      additionalInfo: {
        title: 'Additional Info',
        disclaimer: 'Fill additional info about position',
      },
    },
    positionRecord: {
      sectionsTitle: 'Position Details',
      showMoreText: 'Show more',
      showLessText: 'Show less',
      linkToPositions: 'Positions',
      positionStatus: 'Position status',
      hiringManager: 'Hiring manager',
      company: 'Company',
      accordionCollapsedText: 'Progress',
      accordionExpandedText: 'Approval path',
      closePosition: {
        buttonText: 'Close Position',
        cancelText: 'No',
        okText: 'Yes',
        text: 'Are you sure you want to close this position?',
        title: 'Caution',
        progressInfo: 'Please wait while position: {position} is closed',
        actionTitle: 'Closing position {position}',
        successInfo: 'Position {position} closed successfully',
      },
      positionDetails: {
        submittalsSubtitle: 'Submittals',
        interviewSubtitle: 'Interview',
        offersSubtitle: 'Offers',
        candidateAcceptedSubtitle: 'Candidate Accepted',
        fullPlacementSubtitle: 'Full Placement',
      },
      aboutPosition: {
        title: 'About Position',
        numberOfPositions: 'No. of Positions',
        positionType: 'Position Type',
        positionTitle: 'Position Title',
        positionDescription: 'Position Description',
        clientProject: 'Client Project',
        folderGroup: 'Folder Group',
        industry: 'Industry',
        primaryDepartment: 'Primary Department',
        supervisor: 'Supervisor',
        workHours: 'Workhours',
      },
      schedule: {
        title: 'Schedule',
        duration: 'Duration',
        endTime: 'End Time',
        estimatedStartDate: 'Estimated Start Date',
        estimatedEndDate: 'Estimated End Date',
        shiftType: 'Shift Type',
        startTime: 'Start Time',
      },
      billing: {
        title: 'Billing',
        targetBillRate: 'Bill Rate',
        estimatedSpend: 'Estimated Spend',
        requestFunding: 'Request Funding',
        requestFundingDetails: 'Request Funding Details',
        processingProfile: 'Processing Profile',
        timesheetApprover: 'Timesheet Approver',
      },
      location: {
        title: 'Location',
        worksiteAddress: 'Worksite Address',
        facilityDepartments: 'Departments',
        workFromHome: 'Work From Home',
      },
      additionalInfo: {
        title: 'Additional Info',
      },
      tabs: {
        overview: 'Overview',
        notes: 'Notes',
      },
    },
    matchRecord: {
      matchStatus: 'Status:',
      sectionsTitle: 'Match Details',
      accordionCollapsedText: 'Match progress',
      accordionExpandedText: 'Approval path',
      tabs: {
        overview: 'Overview',
        credentials: 'Credentials',
        resume: 'Candidate Details',
        notes: 'Notes',
      },
      general: {
        title: 'General',
        departments: 'Departments',
        positionType: 'Position Type',
        worksite: 'Worksite',
        company: 'Company',
        hiringManager: 'Hiring manager',
        generalComments: 'General Comments',
      },
      attachments: {
        title: 'Attachments',
        footerText: 'View All',
        noAttachments: 'No Attachments',
      },
      billing: {
        title: 'Billing',
        billRate: 'Bill Rate',
      },
      schedule: {
        title: 'Schedule',
        startDate: 'Start Date',
        estimatedEndDate: 'Estimated End Date',
        workHours: 'Work Hours',
        estimatedHoursPerWeek: 'Estimated Hours Per Week',
      },
      people: {
        title: 'People',
        candidateOwner: 'Match Candidate Owner',
        positionOwner: 'Match Position Owner',
        vendor: 'Vendor',
        payrollContact: 'Payroll Contact',
        accountingContact: 'Accounting Contact',
      },
      timeline: {
        changedBy: 'Changed by:',
        date: 'Date:',
        MakeOffer: 'Make Offer',
        rejectionReason: 'Rejection reason:',
        InviteForInterview: 'Invite For Interview',
        Reject: 'Reject',
        more: 'More',
      },
      rejectModal: {
        title: 'Reject Match',
        reasonDetails: 'Reason Details',
        rejectReason: 'Reject Reason',
        selectRejectReason: 'Select reject reason',
        additionalNote: 'Additional Note',
        rejectProgress: 'Please wait while match is rejected',
        rejectSuccess: 'Match successfully rejected',
        reject: 'Reject',
        cancel: 'Cancel',
      },
      offerInterviewModal: {
        makeOffer: 'Make Offer',
        makeOfferConfirm: 'Are you sure you want to make offer?',
        makeOfferProgress: 'Please wait while offer is requested',
        makeOfferSuccess: 'Offer successfully requested',
        yes: 'Yes',
        inviteForInterview: 'Invite For Interview',
        inviteForInterviewConfirm:
          'Are you sure you want to invite for interview?',
        inviteForInterviewProgress: 'Please wait while interview is requested',
        inviteForInterviewSuccess: 'Interview successfully requested',
        cancel: 'Cancel',
      },
      resume: {
        linkedInLink: 'See profile',
        defaultResume: 'Default resume',
        educationHistory: 'Education history',
        workHistory: 'Work history',
        present: 'Present',
        emptyState: 'Resume not provided',
      },
      credentials: {
        emptyState: 'No Credentials for Match {matchId}',
        downloadAll: 'Download All',
        details: 'Details',
        attachments: 'Attachments',
        detailsModal: {
          pageTitle: 'Details',
          title: 'Extra Details',
        },
        attachmentsModal: {
          pageTitle: 'Attachments',
        },
      },
      additionalInfo: {
        title: 'Additional Info',
        disclaimer: 'Fill additional info about match',
      },
      loadingAttachment: 'Loading Attachment...',
      previewNotSupported: 'Preview Not Supported',
    },
    shiftRecord: {
      sectionsTitle: 'Shift Details',
      company: 'Company',
      position: 'Position',
      shiftStatus: 'Status:',
      overnightShift: 'Overnight shift',
      widgetShift: 'Shift:',
      widgetAssignedCandidate: 'Assigned candidate:',
      widgetNoCandidate: 'There is no candidate assigned to this shift',
      general: {
        title: 'General',
        description: 'Description',
        shiftType: 'Shift Type',
        department: 'Department',
        cancellationReason: 'Cancellation Reason',
      },
      bonus: {
        title: 'Bonus',
        bonusPay: 'Bonus Pay',
        bonusBill: 'Bonus Bill',
      },
      schedule: {
        title: 'Schedule',
        startEndTime: 'Start/End Time',
        startDate: 'Start Date',
        endDate: 'End Date',
      },
    },
    approvalPath: {
      status: {
        approved: 'Approved',
        rejected: 'Rejected',
        inProgress: 'In Progress',
        skipped: 'Skipped',
      },
      approversList: {
        pageTitle: 'Approvers',
        pageSubtitle: 'CCO Approval',
        title: 'Approvers',
        subtitle: 'The list of the eligible approvers',
        footerText: 'Min. {number} approvals',
      },
      approve: 'Approve',
      approveConfirm: 'By continuing, you will approve this step',
      cancel: 'Cancel',
      loadingMessage: 'This will take a few seconds',
      note: 'Note',
      reject: 'Reject',
      rejectConfirm: 'By continuing, you will reject this step',
      rejectionReason: 'Rejection Reason',
      stepApproved: 'This step has been approved',
      stepRejected: 'This step has been rejected',
      yes: 'OK',
    },
    broadcastMessages: {
      learnMore: 'Learn more',
    },
    timesheets: {
      title: 'We are working on Timesheets',
      description: 'You can still access Timesheets in ',
      legacyPortal: 'the legacy portal',
    },
    reports: {
      title: 'We are working on Reports',
      description: 'You can still access Reports in ',
      legacyPortal: 'the legacy portal',
    },
  },
  modules: {
    actions: {
      filter: 'Filter',
      save: 'Save',
      cancel: 'Cancel',
      export: 'Export',
      reset: 'Reset',
      apply: 'OK',
    },
    widget: {
      newWidgetWizard: {
        pageTitle: 'Add new widget',
        modalTitle: 'Available widgets',
        insufficientPermissionsText:
          "Your permissions template doesn't allow you to add any widgets of this type",
      },
      actionMenu: {
        add: 'Add New Widget',
      },
      editbar: {
        save: 'Save changes',
        cancel: 'Cancel',
      },
      info: {
        positions: 'POSITIONS',
        matches: 'MATCHES',
        shifts: 'SHIFTS',
      },
      selectWidget: {
        counter: {
          title: 'Counter',
          description:
            'The Counter Widget enables you to add an animated numbered counter to your page.',
        },
        table: {
          title: 'List',
          description:
            'The list type of widget gives you latest items with extended data.',
        },
      },
      counterWidget: {
        title: 'Configure Counter Widget',
        countType: 'Count Type',
        widgetTitleInput: 'Widget Title',
        widgetTitlePlaceholder: 'Enter widget title',
        widgetTitleInputError: 'Title not valid',
        cancelText: 'Back',
        okText: 'Submit',
        matchesText:
          '{value, plural, =0 { matches } one {match} other {matches}}',
        positionsText:
          '{value, plural, =0 { positions } one {position} other {positions}}',
        shiftsText: '{value, plural, =0 { shifts } one {shift} other {shifts}}',
        openPositions: 'Open Positions',
        closedPositions: 'Closed Positions',
        pendingMyApprovalPositions: 'Positions Pending Approvals',
        submittedMatches: 'Submitted Matches',
        endingSoonMatches: 'Ending Soon Matches',
        pendingStartMatches: 'Pending Start Matches',
        pendingMyApprovalMatches: 'Matches Pending Approvals',
        filledShifts: 'Filled Shifts',
        unfilledShifts: 'Unfilled Shifts',
        cancelledShifts: 'Cancelled Shifts',
        currentlyWorkingMatches: 'Currently Working Matches',
      },
      tableWidget: {
        title: 'Configure Table Widget',
        searchType: 'Select Search type',
        widgetTitleInput: 'Widget title',
        widgetTitlePlaceholder: 'Enter widget title',
        widgetTitleInputError: 'Title not valid',
        widgetVisibleColumnsError: 'Please select no more than {max} columns',
        visibleColumns: 'Select visible columns',
        cancelText: 'Back',
        okText: 'Submit',
        seeAllLinkText: 'See All',
        openPositions: 'Open positions',
        closedPositions: 'Closed positions',
        pendingMyApprovalPositions: 'Pending Approvals Positions',
        filledShifts: 'Filled Shifts',
        unfilledShifts: 'Unfilled Shifts',
        cancelledShifts: 'Cancelled Shifts',
        submittedMatches: 'Submitted matches',
        currentlyWorkingMatches: 'Currently working matches',
        pendingMyApprovalMatches: 'Matches Pending Approvals',
        pendingStartMatches: 'Pending Start Matches',
        endingSoonMatches: 'Ending Soon Matches',
        searchTypePlaceholder: 'Select list type',
        noDataMessage: 'No data',
      },
      contextMenu: {
        restore: 'Restore default dashboard',
        refresh: 'Refresh dashboard',
        edit: 'Edit dashboard',
      },
      widgetFrame: {
        contextMenu: {
          remove: 'Remove',
          edit: 'Edit',
        },
      },
      promptRemove: {
        title: 'Are you sure you want to remove this widget?',
        text: 'Current Placements widget will be removed from your dashboard.',
        okText: 'Remove widget',
      },
      promptCancel: {
        title: 'Discard all changes',
        text:
          'Are you sure you want to discard all dashboard changes and restore the original configuration.',
        okText: 'Discard changes',
      },
    },
    error: {
      page404Title: 'Ooops, page not found!',
      page404GoHome: 'Go to Dashboard',
      pageUnauthorizedTitle: 'You are not authorized to view this page',
      pageUnauthorizedGoHome: 'Go to Dashboard',
      genericTitle: 'Ohhh, something went wrong.',
      genericMessage: 'Please contact the administrator',
      genericTryAgain: 'Try again',
    },

    notes: {
      addCommentPlaceholder: 'Add comment...',
      cancel: 'Cancel',
      loadMore: 'Show more notes',
      send: 'Send',
    },
    comments: {
      cancel: 'Cancel',
      delete: 'Delete',
      deleteCaption: 'Are you sure that you want to delete this note?',
      edit: 'Edit',
      empty: 'Nothing to show here',
    },
    dynamicLabels: {
      yes: 'Yes',
      no: 'No',
    },
  },
};

/* we need to flatten messages if we use nested object for react-intl
if we don't use flattenMessages function we would need to have object with this structure
customMessages {
'en-US.vms.widget.counter.text':
  '{value, plural, =0 { No candidates yet! } one {candidate} other {candidates}}',
...
}
https://stackoverflow.com/questions/45783677/react-intl-accessing-nested-messages?answertab=active#tab-top */
const messages = Intl.flattenMessages(customMessages);

export default messages;
